import React from 'react';
import { Ship, Box, FileText, Anchor } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { SectionHeader } from './shared/SectionHeader';

const LOGISTICS_IMAGE = "https://images.unsplash.com/photo-1634638026221-4c1c4cf9f881?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHw0fHxjYXJnbyUyMHNoaXAlMjBjb250YWluZXJzJTIwc2hpcHBpbmclMjBsb2dpc3RpY3N8ZW58MHx8fHwxNzc3Njg2MzA4fDA&ixlib=rb-4.1.0&q=85";

const incotermIcons = [Ship, Anchor, FileText];

export default function LogisticsPackaging() {
  const { t } = useLanguage();
  const incoterms = t('logistics.incoterms');
  const packagingItems = t('logistics.packagingItems');

  return (
    <section id="logistics" className="py-24 md:py-32 bg-white" data-testid="logistics-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader label={t('logistics.sectionLabel')} title={t('logistics.title')} subtitle={t('logistics.subtitle')} />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20">
          {Array.isArray(incoterms) && incoterms.map((term, i) => {
            const Icon = incotermIcons[i];
            return (
              <div
                key={term.code}
                className="bg-white border border-slate-200 p-8 md:p-10 hover:border-brand-green transition-colors group"
                data-testid={`incoterm-card-${i}`}
              >
                <Icon className="w-10 h-10 text-brand-orange mb-6" />
                <div className="flex items-baseline gap-3 mb-4">
                  <span className="font-heading text-3xl font-black text-brand-green">{term.code}</span>
                  <span className="text-sm text-slate-500 font-medium">{term.name}</span>
                </div>
                <p className="text-slate-600 text-sm leading-relaxed mb-6">{term.description}</p>
                <div className="border-t border-slate-100 pt-4">
                  <p className="text-xs text-slate-400 uppercase tracking-wider font-semibold">Available Ports</p>
                  <p className="text-sm text-slate-700 mt-1 font-medium">{term.ports}</p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
          <div>
            <h3 className="font-heading text-2xl font-bold text-slate-900 mb-8">
              {t('logistics.packagingTitle')}
            </h3>
            <div className="space-y-4">
              {Array.isArray(packagingItems) && packagingItems.map((item) => (
                <div key={item} className="flex gap-4 items-start" data-testid={`packaging-item-${item}`}>
                  <Box className="w-4 h-4 text-brand-green flex-shrink-0 mt-1" />
                  <p className="text-slate-600 text-sm leading-relaxed">{item}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="overflow-hidden">
            <img
              src={LOGISTICS_IMAGE}
              alt="Shipping containers"
              className="w-full h-[400px] object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
